import { AxiosError } from "axios";
import { getApi, patchApi } from "../CreateApi";
import { FormBody, ResponsetGetPersonId, ResposeAllStundets } from "./interfacePerson";

export const getPersonId = async (idPerson: string): Promise<ResponsetGetPersonId> => {
    try {
        const data = await getApi(`/person/${idPerson}`);
        const { id, ...res } = data
        return res
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as ResponsetGetPersonId;
    }
}


export const patchPersonId = async (body: FormBody, idPerson: string): Promise<ResponsetGetPersonId> => {
    try {
        const data = await patchApi(`/person/${idPerson}`, body);

        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as ResponsetGetPersonId;
    }
}

export const getStudentEmail = async (value?: any): Promise<ResposeAllStundets[]> => {
    try {
        const data = await getApi(`/student/autocomplete`, value);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as ResposeAllStundets[];
    }
}